import styled from "react-emotion";

const DisclaimerTitle = styled("h2")`
  margin-top: 10px;
  font-size: 20px;
  margin-left: 10px;
  font-weight: 700;
  color: lightgrey;
`;

export default DisclaimerTitle;


// WEBPACK FOOTER //
// ./src/components/model/Disclaimer/DisclaimerTitle.tsx